import React from 'react';
import { VStack, HStack, Text, Spacer, View } from 'native-base';

import { UserListTableViewCell, TableView } from '../../';

// Redux
import { theme } from '@breakroom-nx/assets';
import { SerializedError } from '@reduxjs/toolkit';
import { User } from '@breakroom-nx/classes';

export interface UserListProps {
  title?: string;
  data: any;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: any;
  refetch: any;
  px?: number;
  pb?: number;
}

export function UserList({
  title,
  data: users,
  isLoading,
  isSuccess,
  isError,
  error,
  refetch,
  px,
  pb,
}: UserListProps) {
  const renderUsers = () => {
    if (users && users.length > 0) {
      return users.map((user: User) => {
        return (
          <UserListTableViewCell
            uid={user.uid}
            username={user.username}
            key={user.uid}
            mb={2}
          />
        );
      });
    } else {
      return;
    }
  };

  return (
    <VStack>
      {title && (
        <View px={8} mb={5}>
          <HStack alignItems={'center'}>
            <HStack alignItems={'baseline'} space={3}>
              <Text variant={'headerMini'}>{title ?? 'Users'}</Text>
              {users && users.length > 0 ? (
                <Text
                  fontWeight={700}
                  fontSize={16}
                  color={theme.colors.surface[400]}
                >
                  {users.length}
                </Text>
              ) : null}
            </HStack>
            <Spacer />
          </HStack>
        </View>
      )}
      <TableView
        isLoading={isLoading}
        isSuccess={isSuccess}
        isError={isError}
        error={isError ? (error as SerializedError) : undefined}
        noData={!users || users.length < 1}
        noDataString={'Error Loading Users'}
        onRefetch={refetch}
        pb={pb}
        px={px}
      >
        {renderUsers()}
      </TableView>
    </VStack>
  );
}

export default React.memo(UserList);
